import { useState } from 'react';
import { Formik } from 'formik';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import FormWrapper from '~FormWrapper';
import SnackForm from './SnackForm';

import { usePatientAndOperatingRooms } from '~hooks/usePatientAndOperatingRooms';
import { useOnSubmit, useOnEdit } from '~hooks';

import { removeEmptyKeys } from '../validations';

const Snack = props => {
  const { formId, edit } = props;
  const { orderId } = useParams();
  const [externalValidations, setExternalValidations] = useState([]);

  const rooms = usePatientAndOperatingRooms();

  const phone = useSelector(state => state.user?.data?.phone);

  const validate = values => {
    const errors = {};

    externalValidations.forEach(validation => {
      const value = values[validation.name];
      const error = validation.getError(value);
      if (error) {
        errors[validation.name] = error;
      }
    });

    if (!values.room) {
      errors.room = 'Vaadittu';
    }

    if (!values.room && !values.location) {
      errors.location = 'Vaadittu';
    }

    if (values.specialDiet === 'YES' && !values.specialDietType) {
      errors.specialDietType = 'Vaadittu';
    }

    return removeEmptyKeys(errors);
  };

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  return (
    <Formik
      initialValues={{
        room: null,
        location: null,
        specialDiet: 'NO',
        warmDish: 'NO',
        sideDish: null,
        specialDietType: null,
        feedingCup: 'NO',
        phone: phone || '',
        comment: '',
        person2: 'NO',
        specialDietPerson2: 'NO',
        warmDishPerson2: 'NO',
        sideDishPerson2: null,
        specialDietTypePerson2: null,
      }}
      validate={validate}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        const method = edit ? onFormEdit : onFormSubmit;

        await method({
          fields: {
            ...values,
          },
          setSubmitting,
          formId,
          orderId,
        });
      }}
    >
      {formikProps => (
        <FormWrapper
          {...props}
          title="Ruokatarjoilu"
          formik={formikProps}
          Component={SnackForm}
          rooms={rooms}
          setExternalValidations={setExternalValidations}
        />
      )}
    </Formik>
  );
};

export default Snack;
